import { createContext, useContext, useState } from "react";

const TooltipContext = createContext();

export function TooltipProvider({ children }) {
  const [tooltipIdx, setTooltipIdx] = useState(null);

  return (
    <TooltipContext.Provider value={{ tooltipIdx, setTooltipIdx }}>
      {children}
    </TooltipContext.Provider>
  );
}

export function useTooltip() {
  return useContext(TooltipContext);
}

// import { createContext, useContext, useState } from "react";

// const TooltipContext = createContext();

// export function TooltipProvider({ children }) {
//   const [tooltipIndex, setTooltipIndex] = useState(null);

//   return (
//     <TooltipContext.Provider value={{ tooltipIndex, setTooltipIndex }}>
//       {children}
//     </TooltipContext.Provider>
//   );
// }

// export function useTooltip() {
//   return useContext(TooltipContext);
// }
